<template>
  <a-card :bordered="false" :bodyStyle="{padding:'20px'}" :headStyle="{borderBottom:'0px',paddingLeft:'20px'}">
    <a-row slot="title">
      <span class="card-title">其他信息</span>
    </a-row>
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      style="margin-top:16px;"
      :columns="columns"
      :request-promise="loadPromise"
    >
      <div slot="indexSlots" slot-scope="rowItem">{{ rowItem.index + 1 }}</div>
      <div slot="action" slot-scope="rowItem">
        <a @click="handleContent(rowItem.record.id)">编辑</a>
      </div>
    </custom-page-table>
  </a-card>
</template>

<script>

export default {
  name: 'OtherInformation',
  data() {
    return {
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' },
          width: '70px'
        },
        {
          title: '页面名称',
          width: '40%',
          dataIndex: 'title'
        },
        {
          title: '修改时间',
          dataIndex: 'gmtModified'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '60px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getModularListPromise(params),
      queryParams: {}
    }
  },
  activated() {
    this.$refs.table.refresh(true)
  },
  methods: {
    handleContent(id) {
      let params = {
        id: id
      }
      this.openNewPage('EditOtherInfo', params)
    },
    getModularListPromise(params) {
      return this.getHttpServices().getUserService().post('pc/v2/other-data/query', params)
    }
  }
}
</script>

<style lang="less">
</style>